import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StaffLoginService {

  private url = environment.url;
  private node_url_v1 = environment.node_url_v1;

  private login_api = 'auth/login';
  private signUp_api = 'auth/signUp';
  private empLogin_api = 'truein_web_api.php?method=empLogin';
  private changeOrganization_api = 'auth/changeOrganization';
  private sendVerifyOtp_api = 'truein_web_api.php?method=sendVerifyOtp';
  private forgotPassword_api = 'auth/forgotPassword';
  private changePassword_api = 'auth/changePassword';
  private verifyUserPassOtp_api = 'truein_web_api.php?method=verifyUserPassOtp';
  private getInvitedUserDetails_api = 'truein_web_api_2.php?method=getInvitedUserDetails';
  private verifyOtp_api = 'auth/verifyOtp';
  private verifyMfaOtp_api = 'auth/verifyMfaOtp';
  private resendMfaOtp_api = 'auth/resendMfaOtp';
  private updatePassword_api = 'truein_web_api.php?method=updatePassword';
  private updateReferralData_api = 'truein_admin_api.php?method=updateReferralData';
  private parentAuthenticate_api = 'parent_authenticate_api.php?method=parentAuthenticate';
  private geoLocationDetails_api = 'truein_ext_api.php?method=getGeoLocationDetails';
  private getCountryMasterList_api = 'truein_admin_api.php?method=getCountryMasterList';
  private getMasterIndustryList_api = 'tst/client-register/getMasterIndustryList';
  // private ipAddress_api = 'https://ipv6.jsonip.com';
  private ipAddress_api = 'https://api64.ipify.org/?format=json';

  private signup_view = new BehaviorSubject<any>('');
  signUpView = this.signup_view.asObservable();

  private trial_signup_loading = new BehaviorSubject<any>(false);
  isTrialSignupLoading = this.trial_signup_loading.asObservable();

  private user_region = new BehaviorSubject<string>('ROW');
  userRegion = this.user_region.asObservable();

  constructor(private http: HttpClient) { }

  setSignupView(value) {
    this.signup_view.next(value);
  }

  setLoadingValue(value) {
    this.trial_signup_loading.next(value);
  }

  setUserRegion(alpha2_iso: string) {
    const region = this.getRegionFromAlpha2Iso(alpha2_iso);
    this.user_region.next(region);
  }

  getRegionFromAlpha2Iso(alpha2_iso: string): string {
    if (!alpha2_iso) {
      return 'ROW';
    }
    
    const alpha2Upper = alpha2_iso.toUpperCase();
    
    // Check for India
    if (alpha2Upper === 'IN') {
      return 'INDIA';
    }
    
    // Check for GCC countries
    const gccCountries = ['BH', 'OM', 'QA', 'SA', 'AE', 'KW'];
    if (gccCountries.includes(alpha2Upper)) {
      return 'GCC';
    }
    
    // Default to Rest of World
    return 'ROW';
  }

  parentAuthenticate(credentials) {
    return this.http.post(this.url + this.parentAuthenticate_api, credentials, {
      headers: new HttpHeaders()
        .set('Content-type', 'application/json')
    });
  }

  login(credentials) {
    return this.http.post(this.node_url_v1 + this.login_api, credentials, {
      headers: new HttpHeaders()
        .set('Content-type', 'application/json'),
      withCredentials: true
    });
  }

  signUp(credentials) {
    return this.http.post(this.node_url_v1 + this.signUp_api, credentials, {
      headers: new HttpHeaders()
        .set('Content-type', 'application/json'),
      withCredentials: true
    });
  }

  empLogin(credentials) {
    return this.http.post(this.url + this.empLogin_api, credentials, {
      headers: new HttpHeaders()
        .set('Content-type', 'application/x-www-form-urlencoded'),
      withCredentials: true
    });
  }

  getInvitedUserDetails(credentials) {
    return this.http.post(this.url + this.getInvitedUserDetails_api, credentials, {
      headers: new HttpHeaders()
        .set('Content-type', 'application/x-www-form-urlencoded'),
      withCredentials: true
    });
  }

  sendVerifyOtp(credentials) {
    return this.http.post(this.url + this.sendVerifyOtp_api, credentials, {
      headers: new HttpHeaders()
      .set('Content-type', 'application/x-www-form-urlencoded')
    });
  }

  forgotPassword(credentials) {
    return this.http.post(this.node_url_v1 + this.forgotPassword_api, credentials, {
      headers: new HttpHeaders()
      .set('Content-type', 'application/json')
    });
  }

  changePassword(credentials) {
    return this.http.post(this.node_url_v1 + this.changePassword_api, credentials, {
      headers: new HttpHeaders()
      .set('Content-type', 'application/json')
    });
  }

  changeOrganization(credentials) {
    return this.http.post(this.node_url_v1 + this.changeOrganization_api, credentials, {
      headers: new HttpHeaders()
        .set('Content-type', 'application/json'),
      withCredentials: true
    });
  }

  verifyUserPassOtp(credentials) {
    return this.http.post(this.url + this.verifyUserPassOtp_api, credentials, {
      headers: new HttpHeaders()
      .set('Content-type', 'application/x-www-form-urlencoded')
    });
  }

  verifyOtp(credentials) {
    return this.http.post(this.node_url_v1 + this.verifyOtp_api, credentials, {
      headers: new HttpHeaders()
      .set('Content-type', 'application/json')
    });
  }

  // MFA OTP verify — backend issues full JWT response on success (same shape as login).
  verifyMfaOtp(credentials) {
    return this.http.post(this.node_url_v1 + this.verifyMfaOtp_api, credentials, {
      headers: new HttpHeaders()
        .set('Content-type', 'application/json'),
      withCredentials: true
    });
  }

  // MFA OTP resend — regenerates and dispatches; FE owns the 60s cooldown timer.
  resendMfaOtp(credentials) {
    return this.http.post(this.node_url_v1 + this.resendMfaOtp_api, credentials, {
      headers: new HttpHeaders()
      .set('Content-type', 'application/json')
    });
  }

  updatePassword(credentials) {
    return this.http.post(this.url + this.updatePassword_api, credentials, {
      headers: new HttpHeaders()
      .set('Content-type', 'application/x-www-form-urlencoded')
    });
  }

  updateReferralData(credentials) {
    return this.http.post(this.url + this.updateReferralData_api, credentials, {
      headers: new HttpHeaders()
      .set('Content-type', 'application/json')
    });
  }

  geoLocationDetails(credentials) {
    return this.http.post(this.url + this.geoLocationDetails_api, credentials, {
      headers: new HttpHeaders()
      .set('Content-type', 'application/json')
    });
  }

  getCountryMasterList() {
    return this.http.post(this.url + this.getCountryMasterList_api, {
      headers: new HttpHeaders()
      .set('Content-type', 'application/json')
    });
  }

  getMasterIndustryList(credentials) {
    return this.http.post(this.node_url_v1 + this.getMasterIndustryList_api, credentials, {
      headers: new HttpHeaders()
      .set('Content-type', 'application/json')
    });
  }

  getIpAddress() {
    return this.http.get<{ip:string}>(this.ipAddress_api);
  }
}
